module.exports = __webpack_public_path__ + "static/media/convex.b6bd0eb2.svg";